<template>
    <sections>
        <section-tiles
            heading="Learn West Coast Swing"
            content="<p>Improvised partner dance</p>"
            :tiles="[
                {
                    url: 'https://www.swingrenegades.co.uk/',
                    image: $config.public.images + 'our-classes.jpg',
                    heading: 'Headingley, UK',
                    excerpt: '<p>Our local classes</p>',
                },
                {
                    url: 'https://www.affinityswing.com/classes',
                    image: $config.public.images + 'global-map.jpg',
                    heading: 'Global Map',
                    excerpt: '<p>Classes around the world</p>',
                },
                {
                    url: 'https://www.udemy.com/course/the-best-couple-dance/',
                    image: $config.public.images + 'online-course.jpg',
                    heading: 'Online Course',
                    excerpt: '<p>Learn to dance online</p>',
                },
            ]"
        ></section-tiles>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'West Coast Swing Links',
    description: 'Where to start!',
    index: true,
});
</script>
